export const DEFAULT_GLB_COLOR_ADJUST = Object.freeze({
  brightness: 100,
  saturation: 100,
  redBoost: 100,
  greenBoost: 100,
  blueBoost: 100,
  roughnessMul: 100,
  roughnessBias: 0,
  metalnessMul: 100,
  normalScale: 100,
  emissiveStrength: 0,
  emissiveColor: "#4c7d2a",
  specularIntensity: 100,
  specularColor: "#ffffff",
  opacity: 100,
  hue: 0,
});

export function createDefaultGlbColorAdjust() {
  return {
    ...DEFAULT_GLB_COLOR_ADJUST,
  };
}

export function createPlantGlbColorPreset() {
  return {
    brightness: 118,
    saturation: 100,
    redBoost: 100,
    greenBoost: 100,
    blueBoost: 100,
    roughnessMul: 100,
    roughnessBias: 0,
    metalnessMul: 100,
    normalScale: 100,
    emissiveStrength: 12,
    emissiveColor: "#4c7d2a",
    specularIntensity: 100,
    specularColor: "#ffffff",
    opacity: 100,
    hue: 0,
  };
}

export function normalizeGlbColorAdjust(adjust = {}) {
  let source = adjust;
  if (typeof source === "string") {
    try {
      source = JSON.parse(source);
    } catch (error) {
      source = {};
    }
  }
  const normalized = {
    ...DEFAULT_GLB_COLOR_ADJUST,
    ...(source || {}),
  };
  const parseNumber = (value, fallback) => {
    const next = Number(value);
    return Number.isFinite(next) ? next : fallback;
  };
  normalized.brightness = parseNumber(
    normalized.brightness,
    DEFAULT_GLB_COLOR_ADJUST.brightness
  );
  normalized.saturation = DEFAULT_GLB_COLOR_ADJUST.saturation;
  normalized.redBoost = DEFAULT_GLB_COLOR_ADJUST.redBoost;
  normalized.greenBoost = DEFAULT_GLB_COLOR_ADJUST.greenBoost;
  normalized.blueBoost = DEFAULT_GLB_COLOR_ADJUST.blueBoost;
  normalized.roughnessMul = DEFAULT_GLB_COLOR_ADJUST.roughnessMul;
  normalized.roughnessBias = DEFAULT_GLB_COLOR_ADJUST.roughnessBias;
  normalized.metalnessMul = DEFAULT_GLB_COLOR_ADJUST.metalnessMul;
  normalized.normalScale = DEFAULT_GLB_COLOR_ADJUST.normalScale;
  normalized.emissiveStrength = parseNumber(
    normalized.emissiveStrength,
    DEFAULT_GLB_COLOR_ADJUST.emissiveStrength
  );
  normalized.specularIntensity = DEFAULT_GLB_COLOR_ADJUST.specularIntensity;
  normalized.opacity = DEFAULT_GLB_COLOR_ADJUST.opacity;
  normalized.hue = DEFAULT_GLB_COLOR_ADJUST.hue;
  normalized.emissiveColor =
    normalized.emissiveColor || DEFAULT_GLB_COLOR_ADJUST.emissiveColor;
  normalized.specularColor = DEFAULT_GLB_COLOR_ADJUST.specularColor;
  return normalized;
}

export function isDefaultGlbColorAdjust(adjust = {}) {
  const normalized = normalizeGlbColorAdjust(adjust);
  return Object.keys(DEFAULT_GLB_COLOR_ADJUST).every((key) => {
    return normalized[key] === DEFAULT_GLB_COLOR_ADJUST[key];
  });
}
